import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";


const PurchaseWiseMIS = () => {
  const [datelist, setDatelist] = useState([]);

  const FillDetail = () => {
    const Datelst = [
      { name: "Purchase Order Detail", reportUrl: "/purchaseorderreport", icon: "fa-file-alt" },
      { name: "Goods Receipt Detail", reportUrl: "/goodsreceiptdetailreport", icon: "fa-box-open" },
      { name: "Purchase Invoice Detail", reportUrl: "/purchaseinvoicereport", icon: "fa-file-invoice" },
      { name: "Goods Return Detail", reportUrl: "/goodsreturnreport", icon: "fa-undo-alt" },
      { name: "Goods Return Invoice", reportUrl: "/goodsreturninvoicereport", icon: "fa-file-invoice-dollar" },
      { name: "Work Services Detail", reportUrl: "/workservicesreport", icon: "fa-tools" },
      { name: "Work Services Invoice", reportUrl: "/workservicesinvoicereport", icon: "fa-file-contract" },
      { name: "Opening Stock Detail", reportUrl: "/openingStockReport", icon: "fa-warehouse" },
      { name: "Direct Goods Receipt", reportUrl: "/directGoodsReceiptReport", icon: "fa-receipt" },
    ];
    setDatelist(Datelst);
  };

  useEffect(() => {
    FillDetail();
  }, []);

  const colors = [
    "#ff6f00", "#009688", "#3f51b5", "#c2185b",
    "#0097a7", "#f57c00", "#5c6bc0", "#388e3c"
  ];

  return (
    <div className="content-wrapper p-4">
      <h4 className="mb-4 text-primary">🧾 Purchase Report Dashboard</h4>

      <div className="row">
        {datelist.map((item, index) => (
          <div className="col-md-4 mb-3" key={index}>
            <Link to={item.reportUrl} className="text-decoration-none">
              <div
                className="report-box d-flex align-items-center shadow-sm p-3 rounded"
                style={{
                  borderLeft: `10px solid ${colors[index % colors.length]}`,
                  backgroundColor: "#fff",
                }}
              >
                <div
                  className="icon-circle d-flex justify-content-center align-items-center mr-3"
                  style={{
                    backgroundColor: colors[index % colors.length],
                    color: "white",
                  }}
                >
                  <i className={`fas ${item.icon}`} />
                </div>
                <div className="report-name text-dark font-weight-bold">{item.name}</div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      <style>{`
        .report-box {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          border-radius: 12px;
        }
        .report-box:hover {
          transform: translateY(-4px);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
        }
        .icon-circle {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          font-size: 18px;
          flex-shrink: 0;
        }
        .report-name {
          font-size: 15px;
          line-height: 1.3;
        }
      `}</style>
    </div>
  );
};

export default PurchaseWiseMIS;
